// GENERATED by scripts/gen-design-tokens.mjs from design/tokens.json. Do not edit by hand.
import type { ThemeTokens } from '../tokens'

/** Signal, dark: the product's dark theme. */
export const signalDark: ThemeTokens = {
  'accent-primary': '#5ab0ff',
  'accent-primary-hover': '#8cc8ff',
  'accent-secondary': '#8cc8ff',
  'font-family': "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', sans-serif",
  'font-family-mono': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Menlo, Consolas, monospace",
  'font-size-xs': '0.75rem',
  'font-size-sm': '0.8125rem',
  'font-size-base': '0.875rem',
  'font-size-md': '1rem',
  'font-size-lg': '1.125rem',
  'font-size-xl': '1.25rem',
  'font-size-2xl': '1.5rem',
  'font-weight-normal': '400',
  'font-weight-medium': '500',
  'font-weight-semibold': '600',
  'font-weight-bold': '600',
  'line-height': '1.5',
  'spacing-xs': '0.25rem',
  'spacing-sm': '0.5rem',
  'spacing-md': '1rem',
  'spacing-lg': '1.5rem',
  'spacing-xl': '2rem',
  'spacing-2xl': '3rem',
  'bg-primary': '#0b0e13',
  'bg-secondary': '#141a22',
  'content-bg': '#0b0e13',
  'text-primary': '#e6eaf0',
  'text-secondary': '#a9b3c1',
  'text-muted': '#8390a0',
  'link-color': '#5ab0ff',
  'link-hover': '#8cc8ff',
  'border-color': '#1e2631',
  'border-strong': '#2a3442',
  'header-height': '52px',
  'header-bg': '#0b0e13',
  'header-text': '#e6eaf0',
  'header-text-muted': '#8390a0',
  'header-hover-bg': '#161d26',
  'sidebar-width': '232px',
  'sidebar-collapsed-width': '56px',
  'sidebar-bg': '#0b0e13',
  'sidebar-text': '#a9b3c1',
  'sidebar-text-hover': '#e6eaf0',
  'sidebar-hover-bg': '#11161d',
  'sidebar-active-bg': '#161d26',
  'sidebar-active-text': '#e6eaf0',
  'card-bg': '#11161d',
  'card-border': '#1e2631',
  'card-header-bg': '#141a22',
  'table-border': '#1a212b',
  'table-header-bg': '#11161d',
  'table-header-text': '#a9b3c1',
  'table-header-hover-bg': '#161d26',
  'table-row-hover': '#141b23',
  'table-row-selected': '#13263a',
  'btn-primary-bg': '#5ab0ff',
  'btn-primary-text': '#06121f',
  'btn-primary-hover': '#8cc8ff',
  'btn-secondary-bg': '#141a22',
  'btn-secondary-text': '#e6eaf0',
  'btn-secondary-border': '#2a3442',
  'btn-secondary-hover': '#1c2430',
  'btn-danger-bg': '#c9353a',
  'btn-danger-text': '#ffffff',
  'btn-danger-hover': '#d9474c',
  'input-bg': '#0b0e13',
  'input-text': '#e6eaf0',
  'input-border': '#2a3442',
  'input-placeholder': '#6b7686',
  'input-focus-border': '#5ab0ff',
  'input-focus-ring': 'rgba(90, 176, 255, 0.25)',
  'status-success': '#3dd68c',
  'status-success-bg': 'rgba(61, 214, 140, 0.12)',
  'status-danger': '#f0605d',
  'status-danger-bg': 'rgba(240, 96, 93, 0.12)',
  'status-warning': '#e8a23a',
  'status-warning-bg': 'rgba(232, 162, 58, 0.12)',
  'status-info': '#5ab0ff',
  'status-info-bg': 'rgba(90, 176, 255, 0.12)',
  'shadow-sm': '0 1px 2px rgba(0, 0, 0, 0.3)',
  'shadow-md': '0 4px 10px rgba(0, 0, 0, 0.35)',
  'shadow-lg': '0 12px 24px rgba(0, 0, 0, 0.4)',
  'shadow-xl': '0 24px 48px rgba(0, 0, 0, 0.5)',
  'radius-sm': '5px',
  'radius-md': '8px',
  'radius-lg': '10px',
  'radius-full': '9999px',
  'transition-fast': '0.12s ease-out',
  'transition-normal': '0.16s ease-out',
  'transition-slow': '0.24s ease-out',
  'z-dropdown': '100',
  'z-sidebar': '200',
  'z-header': '300',
  'z-modal': '400',
  'z-toast': '500',
  'z-tooltip': '600',
  'hover-bg': '#161d26',
  'modal-overlay': 'rgba(3, 6, 10, 0.72)',
  'tooltip-bg': '#e6eaf0',
  'tooltip-text': '#0b0e13',
  'skeleton-base': '#141a22',
  'skeleton-highlight': '#1e2631',
  'terminal-bg': '#0e1218',
  'terminal-fg': '#d5dbe4',
  'terminal-cursor': '#5ab0ff',
  'terminal-ansi-black': '#141a22',
  'terminal-ansi-red': '#f0605d',
  'terminal-ansi-green': '#3dd68c',
  'terminal-ansi-yellow': '#e8a23a',
  'terminal-ansi-blue': '#5ab0ff',
  'terminal-ansi-magenta': '#b392f0',
  'terminal-ansi-cyan': '#4fd1c5',
  'terminal-ansi-white': '#a9b3c1',
  'viewer-bg': '#000000',
  'chart-series-1': '#5ab0ff',
  'chart-series-2': '#3dd68c',
  'chart-series-3': '#e8a23a',
  'chart-series-4': '#f0605d',
  'chart-series-5': '#b392f0',
  'chart-series-6': '#4fd1c5',
  'chart-series-7': '#f472b6',
  'chart-series-8': '#fb923c',
  'chart-warning-fg': '#000000',
  'chart-critical-fg': '#ffffff',
  'ring-label-fg': '#000000',
}
